/* eslint-disable camelcase */
import common_br from './br/common.json';
import common_en from './en/common.json';

export default {
  br: {
    common: common_br,
  },
  en: {
    common: common_en,
  }
};
